import { change, Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import categories from '../../../constants/categories';
import DateTimeInput from '../DateTimeInput/DateTimeInput';
import Dropdown from '../Dropdown';
import { FIELDS } from '../../../constants/eventForm';
import FileInput from '../FileInput';
import InputText from '../InputText';
import LocationInput from '../LocationInput';
import moment from 'moment';
import Style from '../../../styles/common';
import TextArea from '../TextArea';
import { validateNotEmpty } from '../../../helpers/validations';

const Form = styled('form')`
  margin-bottom: ${Style.SPACING.XXL};
  width: ${Style.MEASUREMENT.EVENT_FORM.WIDTH};
`;

class EventForm extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    formName: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  render() {
    return (
      <Form onSubmit={this.props.onSubmit}>
        <Field
          component={InputText}
          label="Title"
          name={FIELDS.TITLE}
          placeholder="Downtown Bermuda Walking Tour"
          type="text"
          validate={validateNotEmpty}
        />
        <Field
          component={FileInput}
          label="Poster"
          name={FIELDS.POSTER}
          placeholder="Upload your file"
          validate={validateNotEmpty}
        />
        <Field
          component={DateTimeInput}
          format={this.formatDateTimeInput}
          label="Start"
          name={FIELDS.START_DATE_TIME}
          normalize={this.normalizeStartDateTimeInput}
          validate={validateNotEmpty}
        />
        <Field
          component={DateTimeInput}
          format={this.formatDateTimeInput}
          label="End"
          name={FIELDS.END_DATE_TIME}
          normalize={this.normalizeDateTimeInput}
          validate={validateNotEmpty}
        />
        <Field
          component={Dropdown}
          format={this.formatDropdownInput}
          label="Categories"
          name={FIELDS.CATEGORIES}
          normalize={this.normalizeDropdownInput}
          options={categories}
          placeholder="Select categories"
          validate={validateNotEmpty}
        />
        <Field
          component={TextArea}
          label="Description"
          name={FIELDS.DESCRIPTION}
          placeholder="e.g. Come for our guided tour of downtown Bermuda and learn about our history. The first part of the tour will..."
          validate={validateNotEmpty}
        />
        <Field
          component={LocationInput}
          label="Location"
          name={FIELDS.LOCATION}
          placeholder="Victoria Park, Hamilton, Bermuda"
          validate={validateNotEmpty}
        />
        {this.props.children}
      </Form>
    );
  }

  formatDateTimeInput = value => value ? moment.unix(value) : undefined;
  normalizeDateTimeInput = data => data && data.unix();
  normalizeStartDateTimeInput = data => {
    const timestamp = this.normalizeDateTimeInput(data);
    if (!timestamp || !this.props.categories || this.props.categories.length === 0) return timestamp;

    const updatedCategories = Object.keys(this.props.categories).reduce((acc, key) => {
      acc[key] = timestamp;
      return acc;
    }, {});
    this.props.change(this.props.formName, FIELDS.CATEGORIES, updatedCategories);
    return timestamp;
  };

  formatDropdownInput = value => {
    if (!value) {
      return undefined;
    }

    return Object.keys(value).map(val => {
      return categories.find(cat => {
        return cat.value === val;
      });
    });
  };

  normalizeDropdownInput = data => {
    // Returns empty string because that will cause redux-form to remove it entirely from the values state
    if (!data || data.length === 0) return '';

    return data.reduce((acc, cat) => {
      acc[cat.value] = this.props.startDateTime || 0;
      return acc;
    }, {});
  };
}

const selector = (form, ...args) => (formValueSelector(form))(...args);

export default connect(
  (state, initialProps) => ({
    categories: selector(initialProps.formName, state, FIELDS.CATEGORIES),
    startDateTime: selector(initialProps.formName, state, FIELDS.START_DATE_TIME),
  }),
  { change }
)(EventForm);



// WEBPACK FOOTER //
// ./src/components/Form/EventForm/EventForm.js